import React, { Component, ComponentType } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { RootState } from '../../store';
import { IEciImplantSelfTestingContainerStateProps, IEciImplantSelfTestingContainerDispatchProps } from '../../interfaces/props/IEciImplantDetailsProps';
import * as eciImplantSelfTestingStore from '../../store/modules/eciImplantSelfTesting.store';
import './selfTestingImplantDetails.container.scss';

import { FormValidator } from '@syncfusion/ej2-react-inputs';
import { IErrors } from '../../common/model/errors.model';
import { isIResponseError, getData, IResponseData, IFile } from '../../common/model/responseError.model';
import { eciImplantsService } from '../../services';
import { notifyErrorWithOptions, notifyInfoWithOptions, notifyWarningWithOptions } from '../../utils/toast.utils';
import { isNullOrWhitespace } from '../../utils/string.utils';
import { AxiosResponse } from 'axios';

type SelfTestingImplantContainerPropsType = PropsFromRedux & RouteComponentProps & WithTranslation;

class SelfTestingImplantDetailsContainer extends Component<SelfTestingImplantContainerPropsType> {
  public fileToUpload: HTMLInputElement = null;
  public file: File;

  private readonly UPLOAD_SELFTESTING_APPFORM_FORM_ID = 'uploadSelfTestingAppFormForm';
  private formValidatorEciForecast: FormValidator = null;
  private formValidator: FormValidator = null;
  private isValidatingAll = false;
  private auxErrors: IErrors = {};

  public constructor(props: SelfTestingImplantContainerPropsType) {
    super(props);
  }

  public closeEciForecast(): void {
    this.formValidatorEciForecast = null;
  }

  public close(): void {
    this.formValidator = null;
  }

  private validateForm(): boolean {
    const { setErrors } = this.props;
    if (!this.formValidator) {
      return true;
    }

    this.isValidatingAll = true;
    const isFormValid = this.formValidator.validate();
    this.isValidatingAll = false;

    if (!isFormValid) {
      setErrors(this.auxErrors);
      this.auxErrors = {};
    } else {
      setErrors({});
    }

    return isFormValid;
  }

  private validateEciForecastForm(): boolean {
    const { setErrors } = this.props;
    if (!this.formValidator) {
      return true;
    }

    this.isValidatingAll = true;
    const isFormValid = this.formValidatorEciForecast.validate();
    this.isValidatingAll = false;

    if (!isFormValid) {
      setErrors(this.auxErrors);
      this.auxErrors = {};
    } else {
      setErrors({});
    }

    return isFormValid;
  }

  public onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null;
    this.file = file;
  };

  public async uploadFilledSelfTestingAppForm(e: React.FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();

    const { i18n, setSpinnerUploadSelfTestingAppForm, user } = this.props;

    setSpinnerUploadSelfTestingAppForm(true);

    try {
      await eciImplantsService.uploadSelfTestingFile(this.file, user.email, 'CIPT');
      notifyInfoWithOptions(i18n.t('eciImplant.uploadSelfTestingAppFormSuccess'), { autoClose: false });

      this.file = null;
      this.fileToUpload.value = '';
    } catch (ex) {
      let errors: IErrors = {};
      let response: AxiosResponse = null;
      if (isIResponseError(ex)) {
        errors = ex.errors;
        response = ex.bodyResponse
      } else {
        errors = ex as IErrors;
      }

      if (response) {
        getData(response).then((data: IResponseData) => {
          const message = data !== undefined && data != null
            ? data.error !== undefined && data.error != null
              ? data.error.message !== undefined && data.error.message != null && data.error.message.trim() != ''
                ? data.error.message
                : data.error.messageException
              : ''
            : 'The response does not have a defined message';

          if (!isNullOrWhitespace(message)) {
            notifyErrorWithOptions(`${i18n.t('eciImplant.uploadSelfTestingAppFormError')}. ERROR: ${message}`, { autoClose: false });
          } else {
            notifyErrorWithOptions(`${i18n.t('eciImplant.uploadSelfTestingAppFormError')}.`, { autoClose: false });
          }
        });
      } else {
        notifyErrorWithOptions(`${i18n.t('eciImplant.uploadSelfTestingAppFormError')}. ERROR: ${errors}`, { autoClose: false });
      }
    } finally {
      setSpinnerUploadSelfTestingAppForm(false);
    }
  }

  private GetBlobFile(file: IFile): Blob {
    if (file !== undefined && file != null && file.stream !== undefined && file.stream != null) {
      // Convertir el archivo base64 a un Blob
      const byteCharacters = atob(file.stream);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: file.mimeType });

      return blob;
    }

    return null;
  }

  public async downloadGarmentsTemplateClick(): Promise<void> {
    try {
      await eciImplantsService.downloadSelfTestingTemplateGarmentsFile();
    } catch (ex) {
      let response: AxiosResponse = null;
      if (isIResponseError(ex)) {
        response = ex.bodyResponse
      }

      if (response) {
        getData(response).then((data: IResponseData) => {
          const message = data !== undefined && data != null
            ? data.error !== undefined && data.error != null
              ? data.error.message !== undefined && data.error.message != null && data.error.message.trim() != ''
                ? data.error.message
                : data.error.messageException
              : ''
            : 'The response does not have a defined message';

          const file = this.GetBlobFile(data.file);

          if (file != null) {
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = data.file.fileName;
            link.click();
            window.URL.revokeObjectURL(url);

            notifyWarningWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          } else {
            notifyErrorWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          }
        });
      }
    }
  }

  public async downloadShoesTemplateClick(): Promise<void> {
    try {
      await eciImplantsService.downloadSelfTestingTemplateShoesFile();
    } catch (ex) {
      let response: AxiosResponse = null;
      if (isIResponseError(ex)) {
        response = ex.bodyResponse
      }

      if (response) {
        getData(response).then((data: IResponseData) => {
          const message = data !== undefined && data != null
            ? data.error !== undefined && data.error != null
              ? data.error.message !== undefined && data.error.message != null && data.error.message.trim() != ''
                ? data.error.message
                : data.error.messageException
              : ''
            : 'The response does not have a defined message';

          const file = this.GetBlobFile(data.file);

          if (file != null) {
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = data.file.fileName;
            link.click();
            window.URL.revokeObjectURL(url);

            notifyWarningWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          } else {
            notifyErrorWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          }
        });
      }
    }
  }

  public render() {
    const {
      i18n,
      showSpinnerUploadSelfTestingFile
    } = this.props;

    return (
      <div>
        <div>
          <div dangerouslySetInnerHTML={{ __html: i18n.t('eciImplant.infoUploadAppForm') }}></div>
          <form id={this.UPLOAD_SELFTESTING_APPFORM_FORM_ID} encType="multipart/form-data" onSubmit={(e: React.FormEvent<HTMLFormElement>) => { e.preventDefault(); this.uploadFilledSelfTestingAppForm(e); }}>
            <fieldset id='m2'>
              <legend>
                {i18n.t('eciImplant.uploadSelfTestingAppForm')}
                <div className='buttonsInLegend'>
                  <button className='btn btn-sm btn-light' title={i18n.t('eciImplant.downloadGarmentAppForm')} onClick={(e: React.MouseEvent<HTMLButtonElement>) => { e.preventDefault(); this.downloadGarmentsTemplateClick(); }}>
                    <span className='icon icon-app-file-download'></span>
                  </button>
                  <button className='btn btn-sm btn-light' title={i18n.t('eciImplant.downloadShoesAppForm')} onClick={(e: React.MouseEvent<HTMLButtonElement>) => { e.preventDefault(); this.downloadShoesTemplateClick(); }}>
                    <span className='icon icon-app-file-download'></span>
                  </button>
                </div>
              </legend>
              <div dangerouslySetInnerHTML={{ __html: i18n.t('eciImplant.uploadSelfTestingAppFormDescription') }}></div>
              <div className='row'>
                <div className='col'>
                  <div className='form-group marginLeftSelfTesting'>
                    <div className='autocomplete-input'>
                      <div className='autocomplete-label'>{i18n.t('eciImplant.filledAppForm')}</div>
                      <input type='file'
                        ref={(element: HTMLInputElement): HTMLInputElement => this.fileToUpload = element}
                        onChange={this.onFileChange}
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      >
                      </input>
                    </div>
                  </div>
                </div>
                <div className='col'>
                  <button role='submit'
                    className='btn btn-sm btn-light'
                    title={i18n.t('eciImplant.uploadFilledAppForm')}
                    disabled={showSpinnerUploadSelfTestingFile}
                  >
                    <span className={(showSpinnerUploadSelfTestingFile ? 'spinner-border spinner-border-sm' : 'icon icon-app-action-send-email')}></span>
                  </button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IEciImplantSelfTestingContainerStateProps => ({
  errors: state.eciImplantSelfTestingStore.errors,
  user: state.currentUserStore.user,
  showSpinnerUploadSelfTestingFile: state.eciImplantSelfTestingStore.uploadSelfTestingFileSpinner
});

const mapDispatchToProps: IEciImplantSelfTestingContainerDispatchProps = {
  setSpinnerUploadSelfTestingAppForm: eciImplantSelfTestingStore.spinnerUploadSelfTestingAppForm,
  setErrors: eciImplantSelfTestingStore.setErrorsInState
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default compose(
  withRouter,
  withTranslation(),
  connector
)(SelfTestingImplantDetailsContainer) as ComponentType;
